"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var use_window_size_1 = __importDefault(require("../use-window-size"));
var classnames_1 = __importDefault(require("classnames"));
var breakpoints_1 = require("./breakpoints");
function useBreakpoints() {
    var width = (0, use_window_size_1.default)().width;
    var _a = (0, react_1.useState)({
        xs: null,
        sm: null,
        md: null,
        lg: null,
        xl: null,
        current: null,
    }), breakpoints = _a[0], setBreakpoints = _a[1];
    (0, react_1.useEffect)(function () {
        var matches = {
            xs: window.matchMedia(breakpoints_1.CSS_MEDIA_QUERY_XS_MOBILE).matches,
            sm: window.matchMedia(breakpoints_1.CSS_MEDIA_QUERY_MOBILE).matches,
            md: window.matchMedia(breakpoints_1.CSS_MEDIA_QUERY_TABLET).matches,
            lg: window.matchMedia(breakpoints_1.CSS_MEDIA_QUERY_ONLY_DESKTOP).matches,
            xl: window.matchMedia(breakpoints_1.CSS_MEDIA_QUERY_XL_DESKTOP).matches,
        };
        setBreakpoints(__assign(__assign({}, matches), { current: (0, classnames_1.default)({
                xs: matches.xs,
                sm: matches.sm,
                md: matches.md,
                lg: matches.lg,
                xl: matches.xl,
            }) }));
    }, [width]);
    return breakpoints;
}
exports.default = useBreakpoints;
//# sourceMappingURL=index.js.map